import { sha256 } from 'hash.js'

export const getSha256Hash = (data: string) => {
  return sha256().update(data).digest('hex')
}
